import { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { AppShell } from "./app-shell.js";
import { RouteLoading } from "./route-boundaries.js";
import { useAuth } from "../features/auth/auth-context.js";

// Keep marketing code out of the authenticated root bundle.
const LandingPage = lazy(async () => {
  const module = await import("../features/landing/landing-page.js");
  return { default: module.LandingPage };
});

const PlanListPage = lazy(async () => {
  const module = await import("../features/plans/plan-list-page.js");
  return { default: module.PlanListPage };
});

export function RootRoute() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === "loading") {
    return <RouteLoading />;
  }
  if (auth.status === "authenticated" && auth.organization === null) {
    return <Navigate replace to="/onboarding" />;
  }
  if (auth.status === "anonymous") {
    if (location.pathname !== "/") {
      return <Navigate replace state={{ from: location.pathname }} to="/login" />;
    }
    return (
      <Suspense fallback={<RouteLoading />}>
        <LandingPage />
      </Suspense>
    );
  }
  return <AppShell />;
}

export function PlanListRoute() {
  return (
    <Suspense fallback={<RouteLoading />}>
      <PlanListPage />
    </Suspense>
  );
}

export function NotFoundPage() {
  return (
    <main className="not-found-page">
      <h1>Page not found</h1>
      <p>The page you requested does not exist.</p>
      <a href="/">Return to PakPlan</a>
    </main>
  );
}
